import { getStandardAvatarUrl } from '@/components/General/avatarHelpers';
import { Avatar } from '@mantine/core';
import { forwardRef } from 'react';

const StandardAvatar = forwardRef(({ type = 'user', url, entityId, size = 40, ...props }, ref) => {
  const src = getStandardAvatarUrl({ type, entityId, url, size });
  const fallbackLetter = type?.[0]?.toUpperCase() || 'A';

  return (
    <Avatar ref={ref} radius="xl" size={size} src={src} {...props}>
      {!src ? fallbackLetter : null}
    </Avatar>
  );
});

StandardAvatar.displayName = 'StandardAvatar';

export default StandardAvatar;
